import { Link } from 'react-router-dom'

export function NotFoundPage() {
  return (
    <div className="min-h-screen bg-[#09090b] flex items-center justify-center p-6">
      <div className="text-center">
        <p className="text-8xl font-bold text-[#e8e8ec]/10 select-none">404</p>
        <h1 className="text-2xl font-bold text-[#e8e8ec] mt-4">Seite nicht gefunden</h1>
        <p className="text-[#b0aeb8] mt-2 max-w-sm mx-auto">
          Die angeforderte Seite existiert nicht oder wurde verschoben.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 mt-8 px-6 py-3 bg-white text-black text-sm font-medium rounded-lg hover:bg-white/90 transition-colors"
        >
          Zurueck zum Dashboard
        </Link>
      </div>
    </div>
  )
}
